import { Modal, Select } from 'antd';
import React, { useMemo, useState } from 'react';
import { userInfo } from '../../../../../models/entities/user';

type Props = {
    visible: boolean;
    localization: any;
    loading: boolean;
    users: userInfo[];
    onCancel: () => void;
    onSubmit: (email: string) => Promise<void>;
};

const AddPlatformAdminModal = ({ visible, localization, loading, users, onCancel, onSubmit }: Props) => {
    const [email, setEmail] = useState('');

    const options = useMemo(
        () =>
            users
                .filter((u) => u.email)
                .map((u) => ({
                    value: u.email,
                    label: `${[u.firstName, u.lastName].filter(Boolean).join(' ') || u.email} — ${u.email}${u.companyName ? ` (${u.companyName})` : ''}`
                })),
        [users]
    );

    const handleOk = async () => {
        if (!email.trim()) return;
        await onSubmit(email.trim());
        setEmail('');
    };

    return (
        <Modal
            title={localization.add_modal.title}
            open={visible}
            okText={localization.add_modal.submit}
            cancelText={localization.add_modal.cancel}
            confirmLoading={loading}
            onCancel={() => {
                setEmail('');
                onCancel();
            }}
            onOk={handleOk}
            destroyOnClose
        >
            <Select
                showSearch
                style={{ width: '100%' }}
                placeholder={localization.add_modal.user_placeholder}
                value={email || undefined}
                options={options}
                optionFilterProp="label"
                onChange={(value) => setEmail(value)}
            />
        </Modal>
    );
};

export default AddPlatformAdminModal;
